<template>
	<LayoutList>
		<template slot="alt-header">
            <ContentHeader
                :title="pageTitle"
                :bordered="false"
            >
                <template slot="custom-back"><slot name="back"></slot></template>
                <template slot="actions" v-if="can('createInsights')">
                    <router-link :to="{ name: 'create-document' }" class="btn btn--primary">
                        Create Document
                    </router-link>
                </template>
                <template slot="title-extra" v-if="can('createInsightCategories')">
                    <router-link :to="{ name: 'edit-document-category', params: { category_id: type } }" class="small-edit">
                        <span>Edit</span>
                        <SvgIcon icon="edit" :is-filled="true" />
                    </router-link>
                </template>
            </ContentHeader>
		</template>

		<template slot="filters">
			<FormControlSector
                name="sectors"
                v-model="filteredFilters.sectors"
                :multiple="true"
                :include-ancestors="false"
            />
			<FormControlInsightCategory
                name="category"
                v-model="filteredFilters.category"
                v-if="!hideCategory"
                :multiple="true"
                :include-ancestors="false"
            />
            <FormControlMember
                name="member"
                v-model="filteredFilters.member"
                placeholder="Select..."
                label="Member company"
            />
            <FormControlDatepicker
                name="fromDate"
                v-model="filteredFilters.fromDate"
                label="From date"
            />
            <FormControlDatepicker
                name="toDate"
                v-model="filteredFilters.toDate"
                label="To date"
            />
        </template>

		<div class="form__group search" slot="search">
			<label for="local-search" class="form__label">Search Insights</label>
			<input
                id="local-search"
                class="form__control search"
                type="search"
                placeholder="Search Insights..."
			    v-model="filters.query"
            />
		</div>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="all" title="All Insights">
				<ListInsights ref="all" :load-on-start="false" :filters="filters" />
			</v-tab>
			<v-tab id="mine" title="My Insights">
				<ListInsights ref="mine" :load-on-start="false" :filters="filters" :mine-only="true" />
			</v-tab>
		</vue-tabs>
	</LayoutList>
</template>
<script>
	import { mapGetters } from 'vuex';
	import LayoutList from '@components/Layout/LayoutList';
	import ListInsights from '@components/List/ListInsights';
	import FormControlSector from '@components/Form/Control/FormControlSector';
	import FormControlInsightCategory from '@components/Form/Control/FormControlInsightCategory';
	import TabbedPage from '@components/TabbedPage';
    import FiltersFromUrl from '@components/FiltersFromUrl';
    import FormControlMember from '@components/Form/Control/FormControlMember';
    import FormControlDatepicker from '@components/Form/Control/FormControlDatepicker';
    import ContentHeader from '@components/Header/ContentHeader.vue';
    import SvgIcon from '@components/SvgIcon.vue';

    export default {
		name: 'InsightList',
		mixins: [ TabbedPage, FiltersFromUrl ],
		components: {
            SvgIcon,
            ContentHeader,
			FormControlInsightCategory,
			FormControlSector,
            FormControlMember,
            FormControlDatepicker,
			ListInsights,
			LayoutList,
		},
        props: {
            hideCategory: {
                type: Boolean,
                default: false,
            },
            backLink: {
                type: Boolean,
                default: false,
            },
            type: {
                type: Number,
                default: null,
            },
            pageTitle: {
                type: String,
                default: "Insights",
            }
        },
		data() {
			return {
				filters: {
                    sectors: [],
                    category: this.type || null,
                    member: null,
                    query: null,
                    fromDate: null,
                    toDate: null
				},
				defaultTab: 'all',
			}
		},
		computed: {
			...mapGetters([ 'can', 'insights' ]),
            filteredFilters() {
                return {
                    query: this.filters.query,
                    sectors: this.sectors,
                    category: this.category,
                    member: this.filters.member,
                    fromDate: this.filters.fromDate,
                    toDate: this.filters.toDate
                }
            },
            sectors: {
                get() {
                    return this.filters.sectors.filter(function (el) {
                        return el !== 0;
                    });
                },
                set(value) {
                    this.filters.sectors = value;
                }
            }
        },
		watch: {
			filters: {
				deep: true,
				handler() {
					this.$store.commit('modifyInsights', {
                        query: this.filters.query,
                        sectors: this.sectors,
                        member: this.filters.member,
                        fromDate: this.filters.fromDate,
                        toDate: this.filters.toDate
					});

                    this.$refs.all.resetPagination();
                    this.$refs.mine.resetPagination();
				}
			}
		},
		methods: {
			load() {
				// this.filters.query = this.insights.query;
				// this.filters.sectors = this.insights.sectors;
				// this.filters.folder = this.insights.folder_location;
			},
		},
		created() {
			this.load();
		},
	}
</script>
